var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('VueElementLoading',{attrs:{"active":_vm.mostrarLoading,"is-full-screen":true,"spinner":"bar-fade-scale","color":"var(--secondary)","text":_vm.mensagem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }